'use strict';

//Wix site fullscreen mode: This is called from fullscreen.html
//implemented as a hidden page in the site
import React from 'react'
import ReactDOM from 'react-dom'
import FullscreenContainer from './fullscreenContainer.js'
import { Provider } from 'react-redux'
import { createStore, applyMiddleware } from 'redux'
import thunkMiddleware from 'redux-thunk'
import createLogger from 'redux-logger'
import fullscreenReducers from '../../reducers/index.js'
import {utils} from '../../utils/utils'
import WixStoreApi from '../../store/storeApi';
import {create} from 'fedops-logger'

$(document).ready(() => {
  var content = document.getElementById('fullscreen');

  try {
    window.fedopsLogger = create('pro-gallery-statics-fullscreen')
    fedopsLogger.appLoaded()
  } catch(e) {
    console.error('fedopsLogger: apploaded failed', e)
  }

  let loggerMiddleware = createLogger();

  var store = createStore(fullscreenReducers,
    applyMiddleware(
      thunkMiddleware,
      loggerMiddleware
    )
  );
  if (utils.isStoreGallery()) {
      // Optimization to store gallery data in cache
      WixStoreApi.getStoreGalleryData();
  }
  if (utils.isInWix()) {
    try {
      Wix.Features.isSupported(Wix.Features.Types.ADD_COMPONENT, (isNewEditor) => {
        if (isNewEditor === false) {
          var elem = React.createElement(FullscreenContainer, { isNewEditor: false });
          ReactDOM.render(elem, content);
        }
      });
    } catch (e) {}
  }

  if (content) {
    var elem = (
      <Provider store={store}>
        <FullscreenContainer
          isNewEditor="true"
        />
      </Provider>
    );
    ReactDOM.render(elem, content);
  } else {
    //in karma, this file is loaded but there is no document
    //console.error('Missing content element for react');
  }
});



// WEBPACK FOOTER //
// ./components/fullscreen/main.js